import { createAction } from '@reduxjs/toolkit';
import { ProfileRequirement } from 'redux/schemas/models/profile-requirement';

// eslint-disable-next-line import/prefer-default-export
export const patchProfileRequirement = createAction<{
  profileRequirementId: number,
  profileRequirementPatch: Partial<ProfileRequirement>,
}>('PATCH_PROFILE_REQUIREMENT');
